/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Login_FailedInputs */

const en_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login failed`)
};

const de_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung fehlgeschlagen`)
};

const fr_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion échouée`)
};

const es_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de inicio de sesión`)
};

const it_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso non riuscito`)
};

const nl_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen mislukt`)
};

const pl_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie nie powiodło się`)
};

const fi_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjautuminen epäonnistui`)
};

const da_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login mislykkedes`)
};

const sv_auth_error_login_failed = /** @type {(inputs: Auth_Error_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggning misslyckades`)
};

/**
* | output |
* | --- |
* | "Login failed" |
*
* @param {Auth_Error_Login_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_error_login_failed = /** @type {((inputs?: Auth_Error_Login_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Login_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_error_login_failed(inputs)
	if (locale === "fr") return fr_auth_error_login_failed(inputs)
	if (locale === "es") return es_auth_error_login_failed(inputs)
	if (locale === "it") return it_auth_error_login_failed(inputs)
	if (locale === "nl") return nl_auth_error_login_failed(inputs)
	if (locale === "pl") return pl_auth_error_login_failed(inputs)
	if (locale === "fi") return fi_auth_error_login_failed(inputs)
	if (locale === "da") return da_auth_error_login_failed(inputs)
	if (locale === "sv") return sv_auth_error_login_failed(inputs)
	return en_auth_error_login_failed(inputs)
});